import React, { useState } from 'react';
import { X, Upload } from 'lucide-react';

function MediaModal({ chatId, onClose }) {
  const [file, setFile] = useState(null);
  const [previewURL, setPreviewURL] = useState('');
  const [caption, setCaption] = useState('');
  const [uploading, setUploading] = useState(false);

  function pickFile(e) {
    const f = e.target.files?.[0];
    if (!f) return;
    setFile(f);
    setPreviewURL(URL.createObjectURL(f));
  }

  function onDrop(e) {
    e.preventDefault();
    const f = e.dataTransfer.files?.[0];
    if (!f) return;
    setFile(f);
    setPreviewURL(URL.createObjectURL(f));
  }

  function onDragOver(e) {
    e.preventDefault();
  }

  async function sendImage() {
    if (!file) return;
    setUploading(true);

    try {
      const fd = new FormData();
      fd.append('image', file, file.name);
      if (caption?.trim()) fd.append('caption', caption.trim());

      const resp = await fetch(
        `${process.env.REACT_APP_API_URL}/api/admin/chats/${chatId}/media`,
        { method: 'POST', body: fd }
      );

      if (!resp.ok) {
        const err = await resp.text();
        console.error('Upload failed:', err);
      }

      onClose();
    } catch (err) {
      console.error('Upload error:', err);
    } finally {
      setUploading(false);
    }
  }

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4"
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div className="w-full max-w-md bg-slate-900 rounded-2xl shadow-2xl border border-slate-700">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-slate-700">
          <h3 className="text-lg font-bold text-white font-montserrat">
            Enviar imagen
          </h3>
          <button
            onClick={onClose}
            className="p-2 hover:bg-slate-800 rounded-lg transition-colors text-slate-400"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Content */}
        <div className="p-4 space-y-4">
          {/* Drop Zone */}
          <div
            onDrop={onDrop}
            onDragOver={onDragOver}
            className="border-2 border-dashed border-slate-700 rounded-xl p-6 text-center bg-slate-800 hover:border-brand-primary transition-colors"
          >
            {previewURL ? (
              <img
                src={previewURL}
                alt="Preview"
                className="max-w-full max-h-64 object-contain mx-auto rounded-lg"
              />
            ) : (
              <div className="py-8">
                <Upload className="w-12 h-12 text-slate-500 mx-auto mb-3" />
                <div className="text-slate-400 mb-2 font-montserrat">
                  Arrastra una imagen aquí
                </div>
                <div className="text-sm text-slate-500 font-montserrat">
                  o haz clic para seleccionar
                </div>
              </div>
            )}
            <div className="mt-4">
              <label className="cursor-pointer text-brand-primary hover:text-brand-primary/80 font-semibold font-montserrat">
                Elegir archivo
                <input
                  type="file"
                  accept="image/*"
                  onChange={pickFile}
                  className="hidden"
                />
              </label>
            </div>
          </div>

          {/* Caption Input */}
          <input
            type="text"
            placeholder="Descripción (opcional)"
            value={caption}
            onChange={e => setCaption(e.target.value)}
            className="w-full px-4 py-2 bg-slate-800 border border-slate-700 text-white rounded-lg outline-none focus:border-brand-primary transition-colors font-montserrat"
          />

          {/* Actions */}
          <div className="flex gap-3">
            <button
              onClick={onClose}
              disabled={uploading}
              className="flex-1 px-4 py-2 bg-slate-800 border border-slate-700 text-white rounded-lg hover:bg-slate-700 transition-colors font-semibold font-montserrat"
            >
              Cancelar
            </button>
            <button
              onClick={sendImage}
              disabled={!file || uploading}
              className="flex-1 px-4 py-2 bg-brand-green text-white rounded-lg font-semibold hover:bg-brand-green/90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed font-montserrat"
            >
              {uploading ? 'Enviando...' : 'Enviar imagen'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MediaModal;